import ReportPairedComparisonPreference from './ReportPairedComparisonPreference';
export default ReportPairedComparisonPreference;